import { camelToKebabCase } from '@/services/stringUtility'
import { clientTabs, siteTabs, projectTabs } from "@/features/schemas/tabs/tabDefinitions";

const defaultComponent = () =>
    import(/* webpackChunkName: "schemaItemView" */ "@/features/schemas/views/SchemaItemView.vue");

// Define custom components here
const customComponents = {
    survey: () =>
        import(/* webpackChunkName: "survey" */ "@/features/surveys/Index.vue"),
    proposal: () =>
        import(/* webpackChunkName: "proposal" */ "@/features/proposals/Proposal.vue"),
    proposalTemplate: () =>
        import(/* webpackChunkName: "proposal" */ "@/features/proposalTemplates/ProposalTemplate.vue"),
    deployment: () =>
        import(/* webpackChunkName: "deploymentPack" */ "@/features/deployments/DeploymentPack.vue"),
    deploymentSnapshot: () =>
        import(/* webpackChunkName: "deploymentSnapshot" */ "@/features/deployments/DeploymentSnapshot.vue")
};

// Define custom static properties here
const customStaticProps = {
    client: {
        tabs: clientTabs
    },
    site: {
        tabs: siteTabs
    },
    project: {
        tabs: projectTabs
    }
};

const entities = [
    "client",
    "file",
    "staffMember",
    "project",
    "role",
    "site",
    "user",
    "region",
    "department"
];

export function hasItemPage(entityKey) {
    return entities.includes(entityKey) || Object.keys(customComponents).includes(entityKey);
}

// Generate route with given entity and custom component if exists
const generateRoute = (e) => ({
    path: `/${camelToKebabCase(e)}/:itemId`,
    name: e,
    staticProps: { entityKey: e, ...customStaticProps[e] },
    component: customComponents[e] || defaultComponent
});

// Create routes for both custom and default entities
const routes = [...Object.keys(customComponents), ...entities].map(generateRoute);

export default routes;
